module.exports = __webpack_public_path__ + "static/media/1007028.1e3bdde5.jpg";